import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AdditionalSettingsService } from '../../services';
import { SnackbarService } from '@shared';
import {
  AdditionalSettingsActionTypes,
  getAdditionalSettingsFailure,
  getAdditionalSettingsSuccess,
  updateAdditionalSettingsFailure,
  updateAdditionalSettingsSuccess,
} from '../actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { IAdditionalSettings } from '@shared/model/basic-data';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorsService } from '@app/errors/errors.service';

@Injectable()
export class AdditionalSettingsEffects {
  constructor(
    private _actions$: Actions,
    private _additionalSettingsService: AdditionalSettingsService,
    private _snackbarService: SnackbarService,
    private _errorsService: ErrorsService,
  ) {}

  getAdditionalSettings$ = createEffect(() =>
    this._actions$.pipe(
      ofType(AdditionalSettingsActionTypes.GET_ADDITIONAL_SETTINGS),
      mergeMap(({ id }) =>
        this._additionalSettingsService.getAdditionalSettings(id).pipe(
          map((additionalSettings: IAdditionalSettings) => getAdditionalSettingsSuccess({ additionalSettings })),
          catchError((err: HttpErrorResponse) => {
            if (err.error.detail) {
              this._errorsService.openPopup(err);
            } else {
              this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            }
            return of(getAdditionalSettingsFailure());
          }),
        ),
      ),
    ),
  );

  updateAdditionalSettings$ = createEffect(() =>
    this._actions$.pipe(
      ofType(AdditionalSettingsActionTypes.UPDATE_ADDITIONAL_SETTINGS),
      mergeMap(({ id, data }) =>
        this._additionalSettingsService.updateAdditionalSettings(id, data).pipe(
          map(() => updateAdditionalSettingsSuccess({ data })),
          catchError(() => of(updateAdditionalSettingsFailure())),
        ),
      ),
    ),
  );
}
